//* Libraries imports
import { useState } from "react";

//* Service imports
import { templateHistoryService } from "@/features/template/TemplateHistoryService";

//* Types imports
import type { ApiError } from "@/types/api";
import type {
  ITemplateHistory,
  TemplateHistoryPayload,
} from "@/features/template/types";

export const useCreateTemplateHistory = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [data, setData] = useState<ITemplateHistory | null>(null);

  const create = async (payload: TemplateHistoryPayload) => {
    setLoading(true);
    setError(null);
    try {
      const response = await templateHistoryService.create(payload);

      if ("code" in response && "message" in response) {
        const apiError = response as ApiError;
        throw new Error(apiError.message);
      }

      if ("data" in response) {
        setData(response.data || null);
        return response.data;
      }

      throw new Error("Resposta inesperada do servidor");
    } catch (err: any) {
      const errorMessage =
        err.message || "Ocorreu um erro ao criar o histórico do template";
      setError(errorMessage);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return { create, loading, error, data };
};
